import React, { useState, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { Modal, List, Icon } from 'semantic-ui-react';
import momentTZ from 'moment-timezone';
import MeetingSettings from './MeetingSettings';
import ZoomInfo from './ZoomInfo';
import ExpertInfo from './ExpertInfo';
import InterviewerInfo from './InterviewerInfo';
import DataContext from '../../contexts/DataContext';
import { JOB_MEETING_CONTEXT } from '../../queries/job';

const MeetingModal = ({ children, job }) => {
  const { user } = useContext(DataContext);
  const [open, setOpen] = useState(false);
  // `interviewers`, `project.team`, and `zoomMeeting.meetingLink` are not
  // loaded by PROJECT_JOBS to keep the list-view payload small.
  // Fetch them on demand when this modal opens.
  const { data } = useQuery(JOB_MEETING_CONTEXT, {
    skip: !open,
    variables: { id: job.id },
  });
  const meeting = data?.job
    ? {
      ...job,
      interviewers: data.job.interviewers,
      zoomMeeting: data.job.zoomMeeting,
      project: { ...job.project, ...data.job.project },
    }
    : job;

  const { expert, project, meetingAt } = job;
  const meetingTime = momentTZ.tz(meetingAt, user.timeZone).format('LLLL z');
  const expertName = job.expert.fullName;

  return (
    <Modal
      closeIcon
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      trigger={children}
      id="meeting-modal"
    >
      <Modal.Header>
        {project.title}
        {job.overall_status === 'Scheduled' && <MeetingSettings job={job} />}
      </Modal.Header>
      <Modal.Content>
        <List>
          <List.Item>
            <Icon name="clock outline" />
            <List.Content>{meetingTime}</List.Content>
          </List.Item>
          {data?.job && <InterviewerInfo meeting={meeting} />}
          <ExpertInfo
            name={expertName}
            title={expert.title}
            organization={expert.organization.name}
          />
          {open && <ZoomInfo job={meeting} />}
        </List>
      </Modal.Content>
    </Modal>
  );
};

export default MeetingModal;
